<template>
  <label
    class="input-group"
    :class="{
      error: error,
      success: successMessage.length > 0,
      disabled: disabled,
    }"
  >
    <span class="input-label"><slot></slot></span>
    <input
      :type="type"
      :value="modelValue"
      :disabled="disabled || inputDisabled"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :required="required"
      :maxlength="maxLength"
      :data-test="dataTest || null"
      :aria-label="errorInputName || dataTest"
      @input="updateValue"
      @keyup.enter="$emit('enterSubmit')"
      @blur="$emit('blur', $event.target.value)"
      @keydown="$emit('onKeyDown', $event)"
    />
    <slot name="icon"></slot>
    <span class="inner-text"><slot name="inner-text"></slot></span>

    <template v-if="showErrorMessage">
      <span
        v-if="customErrorMessage"
        class="error-message"
      >
        {{ customErrorMessage }}
      </span>
      <template v-else>
        <span
          v-if="type === 'email' && error"
          class="error-message"
        >
          Please enter a valid email address
        </span>
        <span
          v-else-if="type === 'tel' && error"
          class="error-message"
        >
          Please enter a valid phone number
        </span>
        <span
          v-else-if="error && errorInputName.length > 0"
          class="error-message"
        >
          Please enter a valid {{ errorInputName }}
        </span>
      </template>
    </template>

    <p
      v-if="successMessage.length > 0"
      class="success-message"
    >
      {{ successMessage }}
    </p>
  </label>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    showErrorMessage: {
      type: Boolean,
      default: true,
    },
    successMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 150,
    },
    type: {
      type: String,
      default: 'text',
    },
    subType: {
      type: String,
      default: '',
    },
    withForceUpdate: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    errorInputName: {
      type: String,
      default: '',
    },
    customErrorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'enterSubmit', 'blur', 'onKeyDown'],
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value);
      this.withForceUpdate && this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './InputGroup.scss';
</style>
